import request from '@/utils/request'

// 查询用户实名认证分页
export function pageRealName(query) {
  return request({
    url: '/userRealName/realName/page',
    method: 'get',
    params: query
  })
}

// 查询用户实名认证列表
export function listRealName(query) {
  return request({
    url: '/userRealName/realName/list',
    method: 'get',
    params: query
  })
}

// 获取用户实名认证详情
export function getRealName(data) {
  return request({
    url: '/userRealName/realName/detail',
    method: 'get',
    params: data
  })
}

// 根据用户ID获取用户实名认证详情
export function getRealNameByUserId(params) {
  return request({
    url: '/userRealName/realName/detailByUserId',
    method: 'get',
    params: params
  })
}

// 修改用户实名认证
export function editRealName(data) {
  return request({
    url: '/userRealName/realName/edit',
    method: 'post',
    data: data
  })
}

// 导出用户实名认证
export function exportRealName(data) {
  return request({
    url: '/userRealName/realName/export',
    method: 'post',
    data: data
  })
}
